import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_BACKEND_URL;

if (!API_BASE_URL) {
  throw new Error(
    "REACT_APP_BACKEND_URL is not configured.",
  );
}

const publicApi = axios.create({
  baseURL:
    API_BASE_URL.replace(
      /\/+$/,
      "",
    ),

  timeout: 30000,

  withCredentials: true,

  headers: {
    Accept: "application/json",
  },
});

export default publicApi;